let timer = null

function throttle(fn, delay) {
  return function () {
    if (timer) {
      return
    }
    fn.apply(this, arguments)
    timer = setTimeout(() => {
      timer = null
    }, delay)
  }
}

async function initSlider(el) {
  if (el.__slider) return;

  el.__slider = true;

  const itemWrap = el.querySelector('.slider-wrapper');
  const itemChildItem = el.querySelectorAll('.slider-list-item');
  const itemContentItem = el.querySelectorAll('.slider-list-content-item');
  const itemControl = el.querySelectorAll('.slider-control a');
  if (!itemWrap) return;

  let length = el.getAttribute('data-length');
  let index = length && Number(length) > 0 ? Number(length) : itemWrap.children.length / 3;
  let step = index;
  let startX = 0;
  let currentX = 0;
  let isDragging = false; 0

  // 是否有active
  const hasActive = el.hasAttribute('data-active');
  // 是否有video
  const hasVideo = el.querySelectorAll('video').length > 0;
  // 自动获取高度
  const hasAutoheight = el.hasAttribute('data-autoheight');
  // 自动播放
  const hasAutoplay = el.hasAttribute('data-autoplay');

  let autoplayTimer = null;
  let autoplayDelay = 3000;
  let isHovering = false;

  /* 延迟真实宽度 */
  function getItemValue() {
    return new Promise(resolve => {
      let frame = 0;

      function check() {
        frame++;

        if (frame > 10) {
          const itemWidth = el.querySelector('.slider-list-item').getBoundingClientRect().width;
          const itemSpace = el.hasAttribute('data-center') ? (el.getBoundingClientRect().width - itemWidth) / 2 : 0;
          const itemActiveHeight = el.querySelector('.slider-list-item.active')?.getBoundingClientRect().height;

          resolve({
            itemActiveHeight,
            itemWidth,
            itemSpace
          });
        } else {
          requestAnimationFrame(check);
        }
      }

      requestAnimationFrame(check);
    });
  }

  /* 初次获取真实宽度 */
  let {
    itemActiveHeight,
    itemWidth,
    itemSpace
  } = await getItemValue();

  window.addEventListener('resize', async () => {
    ({
      itemActiveHeight,
      itemWidth,
      itemSpace
    } = await getItemValue());
    if (hasAutoheight) {
      getHeight();
    }
    resetPosition();
  });

  setTranslate();

  if (hasAutoheight) {
    getHeight();
  }

  if (hasAutoplay) {
    startAutoplay();
  }

  /* 左右箭头控制 */
  itemControl.forEach((item, i) => {
    if (i == 0) {
      item.addEventListener('click', throttle(function () {
        isDragging = true;
        onDragEnd('left', itemWrap, itemWidth, itemSpace);
      }, 300))
    } else if (i == '1') {
      item.addEventListener('click', throttle(function () {
        isDragging = true;
        onDragEnd('right', itemWrap, itemWidth, itemSpace);
      }, 300))
    }
  })

  // Mouse events
  itemWrap.addEventListener('mouseenter', function (e) {
    if (!hasAutoplay) return;

    isHovering = true;
    stopAutoplay();
  });

  itemWrap.addEventListener('mousedown', function (e) {
    onDragStart(e);
  });

  itemWrap.addEventListener('mousemove', function (e) {
    onDragMove(e)
  });

  itemWrap.addEventListener('mouseup', function (e) {
    onDragEnd(false);
  });

  itemWrap.addEventListener('mouseleave', function (e) {
    onDragEnd(false);

    if (!hasAutoplay) return;

    isHovering = false;
    startAutoplay();
  });

  // Touch events (mobile support optional)
  let touchMoved = false;

  itemWrap.addEventListener('touchstart', function (e) {
    touchMoved = false;
    onDragStart(e);
  }, {
    passive: true
  });

  itemWrap.addEventListener('touchmove', function (e) {
    touchMoved = true;
    onDragMove(e);
  }, {
    passive: true
  });

  itemWrap.addEventListener('touchend', function (e) {
    if (!touchMoved) return;
    onDragEnd(false);
  }, {
    passive: true
  });

  function toggleActive(list, activeIndex) {
    if (!list || list.length === 0) return;

    list.forEach((item, ind) => {
      item.classList.toggle('active', ind === activeIndex);
    });
  }

  function handleVideo(activeIndex) {
    itemChildItem.forEach((item, i) => {
      const video = item.querySelector('video');

      // 当前 slide 没有 video
      if (!video) return;

      // 当前 active
      if (i === activeIndex) {
        video.play().catch(() => { });
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  function getHeight() {
    el.style.height = itemActiveHeight + 'px';
  }

  function startAutoplay() {
    if (!hasAutoplay) return;

    stopAutoplay();

    autoplayTimer = setInterval(() => {
      if (isDragging || isHovering) return;

      index++;
      resetPosition();
    }, autoplayDelay);
  }

  function stopAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  }

  function setTranslate() {
    itemWrap.style.transition = 'none';
    itemWrap.style.transform = `translate3d(-${index * itemWidth - itemSpace}px, 0, 0)`;

    if (hasActive) {
      toggleActive(itemChildItem, index);
      toggleActive(itemContentItem, index - step);
    }

    if (hasVideo) {
      handleVideo(index);
    }
  }

  function resetPosition(delta) {
    itemWrap.style.transition = 'transform 0.25s ease';
    itemWrap.style.transform = `translate3d(-${index * itemWidth - itemSpace}px, 0, 0)`;

    if (index <= step - 1) {
      index = itemWrap.children.length - (step * 2) + index;
    } else if (index >= itemWrap.children.length - step) {
      index = index - (itemWrap.children.length - (step * 2));
    }

    if (hasActive && (delta == null || Math.abs(delta) > 50)) {
      itemChildItem.forEach(item => {
        item.classList.remove('active');

        const video = item.querySelector('video');

        if (video) {
          video.pause();
          video.currentTime = 0;
        }
      });
    }

    setTimeout(() => {
      setTranslate();
    }, 200);
  }

  let moved = false;

  function onDragStart(e) {
    e.preventDefault();

    moved = false;
    isDragging = true;

    if (hasAutoplay) stopAutoplay();

    startX = e.pageX || e.touches[0].pageX;
    currentX = startX;
    itemWrap.style.transition = 'none';
  }

  function onDragMove(e) {
    if (!isDragging) return;

    currentX = e.pageX || e.touches[0].pageX;

    const delta = currentX - startX;

    if (Math.abs(delta) > 5) {
      moved = true;
    }

    itemWrap.style.transform = `translate3d(-${index * itemWidth - itemSpace - delta}px, 0, 0)`;
  }

  function onDragEnd(direction) {
    if (!isDragging) return;

    let delta = null;

    if (!direction) {
      delta = currentX - startX;
      let result = delta / itemWidth;
      result = result > 0 ? Math.ceil(result) : Math.floor(result);

      if (delta < -50 && delta >= -(itemWidth)) {
        index++;
      } else if (delta > 50 && delta <= itemWidth) {
        index--;
      } else if (delta < -(itemWidth)) {
        index += Math.abs(result)
      } else if (delta > itemWidth) {
        index -= Math.abs(result)
      }
    } else {
      if (direction === 'left') {
        index--;
      } else if (direction === 'right') {
        index++;
      }
    }

    resetPosition(delta);
    isDragging = false;

    if (hasAutoplay) startAutoplay();
  }

  itemWrap.addEventListener('click', function (e) {
    if (moved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
};

function initScroll(el) {
  if (el.__initScroll) return;
  el.__initScroll = true;

  const wrapper = el.querySelector('.custom-scroll-wrapper');
  const items = el.querySelectorAll('.custom-scroll-item');
  const prevButton = el.querySelector('.custom-scroll-prev');
  const nextButton = el.querySelector('.custom-scroll-next');

  if (!wrapper || !items.length) return;

  const perPage = Number(el.dataset.perPage) || 4;
  const isMobile = window.matchMedia('(max-width: 767px)').matches;
  const canMouseDrag = el.hasAttribute('data-drag') || isMobile;

  let currentPage = 0;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(value, max));
  }

  function getMaxScrollLeft() {
    return Math.max(0, wrapper.scrollWidth - wrapper.clientWidth);
  }

  function getMaxPage() {
    return Math.max(0, Math.ceil(items.length / perPage) - 1);
  }

  function getItemLeft(item) {
    return item.getBoundingClientRect().left - wrapper.getBoundingClientRect().left + wrapper.scrollLeft;
  }

  function getScrollLeft(page) {
    const maxPage = getMaxPage();

    if (page >= maxPage) {
      return getMaxScrollLeft();
    }

    const targetItem = items[page * perPage];

    if (!targetItem) {
      return getMaxScrollLeft();
    }

    return clamp(getItemLeft(targetItem), 0, getMaxScrollLeft());
  }

  function getClosestPage() {
    const maxPage = getMaxPage();
    const maxScrollLeft = getMaxScrollLeft();

    if (wrapper.scrollLeft >= maxScrollLeft - 1) {
      return maxPage;
    }

    let closestPage = 0;
    let closestDistance = Infinity;

    for (let page = 0; page <= maxPage; page++) {
      const distance = Math.abs(wrapper.scrollLeft - getScrollLeft(page));

      if (distance < closestDistance) {
        closestDistance = distance;
        closestPage = page;
      }
    }

    return closestPage;
  }

  function updateButtons() {
    const maxPage = getMaxPage();

    if (prevButton) {
      prevButton.disabled = currentPage <= 0;
    }

    if (nextButton) {
      nextButton.disabled = currentPage >= maxPage;
    }
  }

  function goToPage(page) {
    const maxPage = getMaxPage();

    currentPage = clamp(page, 0, maxPage);

    wrapper.scrollTo({
      left: getScrollLeft(currentPage),
      behavior: 'smooth'
    });

    updateButtons();
  }

  if (prevButton) {
    prevButton.addEventListener('click', function () {
      goToPage(currentPage - 1);
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      goToPage(currentPage + 1);
    });
  }

  if (canMouseDrag) {
    let pointerDown = false;
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let pointerId = null;

    const dragThreshold = 5;

    function resetDrag() {
      pointerDown = false;
      isDragging = false;
      wrapper.classList.remove('is-dragging');

      currentPage = getClosestPage();
      updateButtons();

      if (
        pointerId !== null &&
        wrapper.hasPointerCapture(pointerId)
      ) {
        wrapper.releasePointerCapture(pointerId);
      }

      pointerId = null;
    }

    wrapper.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;

      pointerDown = true;
      startX = e.clientX;
      startScrollLeft = wrapper.scrollLeft;
      pointerId = e.pointerId;
    });

    wrapper.addEventListener('pointermove', function (e) {
      if (!pointerDown) return;

      const moveX = e.clientX - startX;

      // 移动超过阈值后，才认为是在拖动
      if (!isDragging && Math.abs(moveX) > dragThreshold) {
        isDragging = true;
        wrapper.classList.add('is-dragging');
        wrapper.setPointerCapture(e.pointerId);
      }

      if (!isDragging) return;

      // 防止拖动过程中触发浏览器默认行为
      e.preventDefault();

      wrapper.scrollLeft = clamp(
        startScrollLeft - moveX,
        0,
        getMaxScrollLeft()
      );
    });

    wrapper.addEventListener('pointerup', resetDrag);
    wrapper.addEventListener('pointercancel', resetDrag);
    wrapper.addEventListener('lostpointercapture', resetDrag);

    wrapper.addEventListener('dragstart', function (e) {
      if (pointerDown) {
        e.preventDefault();
      }
    });
  }

  wrapper.addEventListener('scroll', function () {
    currentPage = getClosestPage();
    updateButtons();
  });

  updateButtons();
}

function initClick(el) {
  if (el.__initClick) return;
  el.__initClick = true;

  el.addEventListener('click', function (event) {
    const currentTrigger = event.target.closest('.custom-click-trigger');

    // 确保点击的是当前 custom-click 容器内的 trigger
    if (!currentTrigger || !el.contains(currentTrigger)) return;

    const currentId = currentTrigger.dataset.id;
    if (!currentId) return;

    // CSS.escape 防止 ID 中存在特殊字符
    const currentTarget = el.querySelector(
      `.custom-click-target#${CSS.escape(currentId)}`
    );

    if (!currentTarget) return;

    // 是否允许重复点击切换
    const canToggle = currentTrigger.hasAttribute('data-toggle');

    // 当前是否已经激活
    const isActive =
      currentTrigger.classList.contains('active') &&
      currentTarget.classList.contains('active');

    // 没有 data-toggle，且已经激活，再次点击不执行任何操作
    if (!canToggle && isActive) return;

    // 有 data-toggle 时，重复点击切换 active
    const shouldActivate = canToggle ? !isActive : true;

    if (canToggle) {
      /*
       * toggle 模式：
       * 当前项可以展开和收起。
       * 其他项仍然移除 active。
       */
      el.querySelectorAll('.custom-click-trigger').forEach(function (trigger) {
        trigger.classList.toggle(
          'active',
          shouldActivate && trigger === currentTrigger
        );
      });

      el.querySelectorAll('.custom-click-target').forEach(function (target) {
        const isCurrentTarget = target === currentTarget;

        target.classList.toggle(
          'active',
          shouldActivate && isCurrentTarget
        );

        // 其他 target 恢复收起高度
        if (!isCurrentTarget) {
          setCollapsedHeight(target);
        }
      });
    } else {
      /*
       * 普通模式：
       * 当前项添加 active，其他项移除 active。
       */
      el.querySelectorAll('.custom-click-trigger').forEach(function (trigger) {
        trigger.classList.toggle('active', trigger === currentTrigger);
      });

      el.querySelectorAll('.custom-click-target').forEach(function (target) {
        const isCurrentTarget = target === currentTarget;

        target.classList.toggle('active', isCurrentTarget);

        if (!isCurrentTarget) {
          setCollapsedHeight(target);
        }
      });
    }

    if (shouldActivate) {
      setExpandedHeight(currentTarget);
    } else {
      setCollapsedHeight(currentTarget, currentTrigger);
    }
  });

  /**
   * 展开时，将内容真实高度写入 --m-h
   */
  function setExpandedHeight(target) {
    // 优先查找指定的内容元素
    const content =
      target.querySelector('[data-height-content]') ||
      target.firstElementChild;

    if (!content) return;

    /*
     * scrollHeight 可以获得元素完整内容高度，
     * 包括当前被 max-height 隐藏的部分。
     */
    const contentHeight = content.scrollHeight;

    target.style.setProperty('--m-h', `${contentHeight}px`);

    /*
     * 图片或异步内容可能在点击后改变高度，
     * 下一帧再计算一次会更准确。
     */
    requestAnimationFrame(function () {
      target.style.setProperty('--m-h', `${content.scrollHeight}px`);
    });
  }

  /**
   * 收起时，将 --m-h 恢复为 data-height
   */
  function setCollapsedHeight(target, trigger) {
    const height =
      target.dataset.height ||
      trigger?.dataset.height;

    if (height === undefined || height === '') return;

    target.style.setProperty('--m-h', normalizeHeight(height));
  }

  /**
   * data-height="200" 自动转换成 200px；
   * data-height="10rem"、"50vh" 等单位保持不变。
   */
  function normalizeHeight(height) {
    const value = String(height).trim();

    return /^-?\d+(\.\d+)?$/.test(value)
      ? `${value}px`
      : value;
  }
}

function initArticleToc(toc) {
  if (!toc) return;

  const article = document.querySelector('.t4s-article-content');
  if (!article) return;

  const headings = Array.from(
    article.querySelectorAll('h2, h3')
  ).filter(heading => heading.textContent.trim());

  if (!headings.length) {
    toc.innerHTML = '';
    delete toc.dataset.tocSignature;
    return;
  }

  const headingSignature = headings
    .map(heading => `${heading.tagName}:${heading.textContent.trim()}`)
    .join('|');

  if (
    toc.dataset.tocSignature === headingSignature &&
    toc.querySelector('.article-toc__list')
  ) {
    return;
  }

  toc.dataset.tocSignature = headingSignature;
  toc.innerHTML = '';

  const list = document.createElement('ol');
  list.className = 'article-toc__list';

  let currentH2Item = null;
  let currentSubList = null;

  // 编号
  let h2Index = 0;
  let h3Index = 0;

  headings.forEach(heading => {
    const item = document.createElement('li');
    const button = document.createElement('button');

    button.type = 'button';
    button.className = 'article-toc__link';

    if (heading.tagName === 'H2') {
      h2Index++;
      h3Index = 0;

      const number = String(h2Index).padStart(2, '0');

      const numberSpan = document.createElement('span');
      numberSpan.className = 'article-toc__number';
      numberSpan.textContent = number;

      const textSpan = document.createElement('span');
      textSpan.className = 'article-toc__text';
      textSpan.textContent = heading.textContent.trim();

      button.appendChild(numberSpan);
      button.appendChild(textSpan);
    }

    if (heading.tagName === 'H3') {
      h3Index++;

      const numberSpan = document.createElement('span');
      numberSpan.className = 'article-toc__number';
      numberSpan.textContent = `${h2Index}.${h3Index}`;

      const textSpan = document.createElement('span');
      textSpan.className = 'article-toc__text';
      textSpan.textContent = heading.textContent.trim();

      button.appendChild(numberSpan);
      button.appendChild(textSpan);
    }

    button.addEventListener('click', () => {
      heading.scrollIntoView({
        behavior: window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
          ? 'auto'
          : 'smooth',
        block: 'start'
      });
    });

    heading.style.scrollMarginTop = '100px';

    if (heading.tagName === 'H2') {
      item.className =
        'article-toc__item article-toc__item--h2';

      item.appendChild(button);
      list.appendChild(item);

      currentH2Item = item;
      currentSubList = null;
    }

    if (heading.tagName === 'H3' && currentH2Item) {
      item.className =
        'article-toc__item article-toc__item--h3';

      if (!currentSubList) {
        currentSubList = document.createElement('ol');
        currentSubList.className = 'article-toc__sublist';
        currentH2Item.appendChild(currentSubList);
      }

      item.appendChild(button);
      currentSubList.appendChild(item);
    }
  });

  toc.appendChild(list);
}

const watchList = [
  {
    selector: '.slider-list',
    handler: initSlider,
    flag: '__slider'
  },
  {
    selector: '.custom-scroll',
    handler: initScroll,
    flag: '__initScroll'
  },
  {
    selector: '.custom-click',
    handler: initClick,
    flag: '__initClick'
  },
  {
    selector: '.article-toc',
    handler: initArticleToc
  }
];

// 初次加载
watchList.forEach(item => {
  document.querySelectorAll(item.selector).forEach(node => {
    if (item.flag && node[item.flag]) return;
    item.handler(node);
  });
});

// 统一 MutationObserver 监听
let moTimer = null;

const observer = new MutationObserver(() => {
  clearTimeout(moTimer);
  moTimer = setTimeout(() => {
    watchList.forEach(item => {
      document.querySelectorAll(item.selector).forEach(node => {
        if (item.flag && node[item.flag]) return;
        item.handler(node);
      });
    });
  }, 50);
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});